"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _default(theme) {
  var palette = theme.palette,
      page = {
    width: "".concat(palette.gutter * 3, "px"),
    height: "".concat(palette.gutter * 3, "px"),
    textAlign: 'center',
    color: theme.idleColor,
    background: theme.idleBackground,
    display: 'inline-block',
    fontSize: theme.fontSize,
    lineHeight: "".concat(palette.gutter * 3, "px"),
    verticalAlign: 'middle',
    userSelect: 'none',
    cursor: 'pointer',
    position: 'relative',
    zIndex: 2,
    transition: "color ".concat(palette.transitionDuration, " ").concat(palette.transitionFunction)
  },
      pageSelected = _objectSpread({}, page, {
    background: theme.selectedBackground,
    color: theme.selectedColor
  });

  return {
    root: {
      position: 'relative',
      display: 'inline-flex',
      alignItems: 'center',
      font: "".concat(palette.tsNormal, "/").concat(palette.tlNormal, " \"").concat(palette.fontFamily, "\""),
      color: theme.color,
      whiteSpace: 'nowrap',
      width: theme.width,
      minWidth: theme.minWidth
    },
    pageWrapperSelected: {
      transitionProperty: 'background, color',
      transitionDuration: palette.transitionDuration,
      transitionTimingFunction: palette.transitionFunction,
      borderRadius: theme.borderRadius,
      height: '100%',
      '&:hover': {
        background: theme.selectedHoverBackground,
        color: theme.selectedHoverColor
      }
    },
    pageWrapper: {
      height: '100%',
      borderRadius: theme.borderRadius
    },
    page: _objectSpread({}, page, {
      '&:hover': {
        color: theme.hoverColor,
        background: theme.hoverBackground
      }
    }),
    pageSelected: pageSelected,
    pageSelectedStart: _objectSpread({}, pageSelected, {
      borderTopLeftRadius: theme.borderRadius,
      borderBottomLeftRadius: theme.borderRadius
    }),
    pageSelectedEnd: _objectSpread({}, pageSelected, {
      borderTopRightRadius: theme.borderRadius,
      borderBottomRightRadius: theme.borderRadius
    }),
    pageSelectedSingle: _objectSpread({}, pageSelected, {
      borderRadius: theme.borderRadius
    }),
    incrementButton: {
      marginLeft: "".concat(palette.gutter * 3, "px")
    },
    icon: {
      display: 'flex',
      transition: "opacity ".concat(palette.transitionDuration, " ").concat(palette.transitionFunction)
    },
    decrementButton: {
      marginRight: "".concat(palette.gutter * 3, "px")
    },
    separator: _objectSpread({}, page, {
      cursor: 'default'
    }),
    separatorSelected: _objectSpread({}, pageSelected, {
      cursor: 'default'
    })
  };
}